import { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { api } from '../api';

export default function LoginPage() {
  const { login, register } = useAuth();
  const [tab, setTab] = useState('login');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [resetToken, setResetToken] = useState(null);
  const [resetEmail, setResetEmail] = useState('');

  const [loginForm, setLoginForm] = useState({ email: '', password: '' });
  const [regForm, setRegForm] = useState({ name: '', email: '', password: '', invite_code: '' });
  const [forgotEmail, setForgotEmail] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('reset_token');
    const email = params.get('email');
    if (token && email) {
      setResetToken(token);
      setResetEmail(email);
      setTab('reset');
    }
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError(''); setSuccess('');
    setLoading(true);
    try {
      await login(loginForm.email, loginForm.password);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    setError(''); setSuccess('');
    setLoading(true);
    try {
      await register(regForm.name, regForm.email, regForm.password, regForm.invite_code);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleForgot = async (e) => {
    e.preventDefault();
    setError(''); setSuccess('');
    setLoading(true);
    try {
      await api.forgotPassword(forgotEmail);
      setSuccess('Jeśli email istnieje w systemie, wysłaliśmy link do resetu hasła.');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleReset = async (e) => {
    e.preventDefault();
    setError(''); setSuccess('');
    if (newPassword !== confirmPassword) return setError('Hasła nie są identyczne');
    setLoading(true);
    try {
      await api.resetPassword(resetEmail, resetToken, newPassword);
      setSuccess('Hasło zostało zmienione. Możesz się teraz zalogować.');
      setResetToken(null);
      window.history.replaceState({}, '', window.location.pathname);
      setTab('login');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-header">
          <div className="login-logo">DARTOM</div>
          <div className="login-logo-sub">Kalendarz Urlopowy</div>
        </div>
        <div className="login-body">

          {tab !== 'forgot' && tab !== 'reset' && (
            <div className="login-tabs">
              <button className={`login-tab ${tab === 'login' ? 'active' : ''}`} onClick={() => { setTab('login'); setError(''); setSuccess(''); }}>Logowanie</button>
              <button className={`login-tab ${tab === 'register' ? 'active' : ''}`} onClick={() => { setTab('register'); setError(''); setSuccess(''); }}>Rejestracja</button>
            </div>
          )}

          {error && <div className="alert alert-error">{error}</div>}
          {success && <div className="alert alert-success">{success}</div>}

          {tab === 'login' && (
            <form onSubmit={handleLogin}>
              <div className="form-group">
                <label className="form-label">Email</label>
                <input className="form-input" type="email" required value={loginForm.email} onChange={e => setLoginForm(p => ({ ...p, email: e.target.value }))} placeholder="twoj@email.pl" />
              </div>
              <div className="form-group">
                <label className="form-label">Hasło</label>
                <input className="form-input" type="password" required value={loginForm.password} onChange={e => setLoginForm(p => ({ ...p, password: e.target.value }))} placeholder="••••••••" />
              </div>
              <button className="btn btn-primary" style={{ width: '100%', justifyContent: 'center', marginTop: 4 }} disabled={loading}>
                {loading ? 'Logowanie...' : 'Zaloguj się'}
              </button>
              <div style={{ textAlign: 'center', marginTop: 14 }}>
                <button type="button" onClick={() => { setTab('forgot'); setError(''); setSuccess(''); }} style={{ background: 'none', border: 'none', color: 'var(--dartom-green)', fontSize: 13, cursor: 'pointer', textDecoration: 'underline' }}>
                  Nie pamiętam hasła
                </button>
              </div>
            </form>
          )}

          {tab === 'register' && (
            <form onSubmit={handleRegister}>
              <div className="form-group">
                <label className="form-label">Imię i nazwisko</label>
                <input className="form-input" type="text" required value={regForm.name} onChange={e => setRegForm(p => ({ ...p, name: e.target.value }))} placeholder="Jan Kowalski" />
              </div>
              <div className="form-group">
                <label className="form-label">Email firmowy</label>
                <input className="form-input" type="email" required value={regForm.email} onChange={e => setRegForm(p => ({ ...p, email: e.target.value }))} placeholder="jan.kowalski@dartom.pl" />
              </div>
              <div className="form-group">
                <label className="form-label">Hasło</label>
                <input className="form-input" type="password" required minLength={6} value={regForm.password} onChange={e => setRegForm(p => ({ ...p, password: e.target.value }))} placeholder="Min. 6 znaków" />
              </div>
              <div className="form-group">
                <label className="form-label">Kod dostępu</label>
                <input className="form-input" type="text" required value={regForm.invite_code} onChange={e => setRegForm(p => ({ ...p, invite_code: e.target.value }))} placeholder="Otrzymasz od managera" />
                <div className="form-hint">Kod dostępu jest wymagany do rejestracji — uzyskaj go u managera.</div>
              </div>
              <button className="btn btn-primary" style={{ width: '100%', justifyContent: 'center', marginTop: 4 }} disabled={loading}>
                {loading ? 'Rejestracja...' : 'Zarejestruj się'}
              </button>
            </form>
          )}

          {tab === 'forgot' && (
            <form onSubmit={handleForgot}>
              <h3 style={{ marginBottom: 16, color: 'var(--dartom-green-dark)' }}>Reset hasła</h3>
              <div className="form-group">
                <label className="form-label">Twój email</label>
                <input className="form-input" type="email" required value={forgotEmail} onChange={e => setForgotEmail(e.target.value)} placeholder="twoj@email.pl" />
                <div className="form-hint">Wyślemy link do resetu hasła na ten adres.</div>
              </div>
              <button className="btn btn-primary" style={{ width: '100%', justifyContent: 'center' }} disabled={loading}>
                {loading ? 'Wysyłanie...' : 'Wyślij link'}
              </button>
              <div style={{ textAlign: 'center', marginTop: 14 }}>
                <button type="button" onClick={() => { setTab('login'); setError(''); setSuccess(''); }} style={{ background: 'none', border: 'none', color: 'var(--dartom-green)', fontSize: 13, cursor: 'pointer', textDecoration: 'underline' }}>
                  ← Wróć do logowania
                </button>
              </div>
            </form>
          )}

          {tab === 'reset' && (
            <form onSubmit={handleReset}>
              <h3 style={{ marginBottom: 16, color: 'var(--dartom-green-dark)' }}>Nowe hasło</h3>
              <div className="form-group">
                <label className="form-label">Nowe hasło</label>
                <input className="form-input" type="password" required minLength={6} value={newPassword} onChange={e => setNewPassword(e.target.value)} placeholder="Min. 6 znaków" />
              </div>
              <div className="form-group">
                <label className="form-label">Powtórz hasło</label>
                <input className="form-input" type="password" required minLength={6} value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} placeholder="Min. 6 znaków" />
              </div>
              <button className="btn btn-primary" style={{ width: '100%', justifyContent: 'center' }} disabled={loading}>
                {loading ? 'Zapisywanie...' : 'Ustaw nowe hasło'}
              </button>
            </form>
          )}

        </div>
      </div>
    </div>
  );
}
